module.exports = __webpack_public_path__ + "assets/img/zjcs.c0b83503.png";